import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateAccounts} from 'modules/store/accounts';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        cloud_account_id:    'cloudAccountId',
        identity_service_id: 'identityServiceId'
    },
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformOracle needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.alias,
            reselling: account.reselling,
            vendor:    {
                selected: vendorCodes.oracle,
                values:   {
                    cloudAccountId:    account.cloud_account_id,
                    name:              account.name,
                    id:                account.id,
                    identityServiceId: account.identity_service_id
                }
            }
        };
    },
    transformEntitiesToSaveFn = account => ({
        name:                account.name,
        cloud_account_id:    account.vendor.cloudAccountId,
        identity_service_id: account.vendor.identityServiceId
    });


const exports = storeModuleFactory({
    name:             'oracleAccounts',
    endpoint:         endpoints.accounts.oracle.endpoint,
    instanceEndpoint: endpoints.accounts.oracle.instanceEndpoint,
    callbackActions:  [{
        method: 'update',
        action: invalidateAccounts
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;


module.exports = exports;




// WEBPACK FOOTER //
// ./src/modules/store/oracleAccounts.js